"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1360],{

/***/ 27190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ withResponsiveHOC; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.scss.js


var StyledResponsiveComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e19xbm3d0"
})(".desktop-wrapper{display:block;}.mobile-wrapper{display:none;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.desktop-wrapper{display:none;}.mobile-wrapper{display:block;}}");

;// CONCATENATED MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



function withResponsiveHOC(DesktopComponent, MobileComponent) {
    return /*#__PURE__*/ function(PureComponent) {
        "use strict";
        (0,_inherits/* default */.Z)(ResponsiveComponent, PureComponent);
        var _super = (0,_create_super/* default */.Z)(ResponsiveComponent);
        function ResponsiveComponent() {
            (0,_class_call_check/* default */.Z)(this, ResponsiveComponent);
            return _super.apply(this, arguments);
        }
        (0,_create_class/* default */.Z)(ResponsiveComponent, [
            {
                key: "render",
                value: function render() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledResponsiveComponent, {
                        className: "responsive-hoc-component",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "desktop-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopComponent, _object_spread({}, this.props))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mobile-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileComponent, _object_spread({}, this.props))
                            })
                        ]
                    });
                }
            }
        ]);
        return ResponsiveComponent;
    }(react.PureComponent);
}


/***/ }),

/***/ 28391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ carousel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/lodash.throttle/index.js
var lodash_throttle = __webpack_require__(93096);
var lodash_throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/default-props.js
var default_props = __webpack_require__(26687);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/core-components/carousel/slick.scss.js
var slickStyle = '\n  .slick-slider {\n    position: relative;\n    display: block;\n    box-sizing: border-box;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -ms-touch-action: pan-y;\n    touch-action: pan-y;\n    -webkit-tap-highlight-color: transparent;\n  }\n  \n  .slick-loading .slick-slide {\n    visibility: hidden;\n  }\n    \n  .slick-list {\n    position: relative;\n    overflow: hidden;\n    display: block;\n    margin: 0;\n    padding: 0;\n\n    &:focus {\n      outline: none;\n    }\n\n    &.dragging {\n      cursor: pointer;\n      cursor: hand;\n    }\n  }\n  .slick-slider .slick-track,\n  .slick-slider .slick-list {\n    -webkit-transform: translate3d(0, 0, 0);\n    -moz-transform: translate3d(0, 0, 0);\n    -ms-transform: translate3d(0, 0, 0);\n    -o-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  .slick-track {\n    position: relative;\n    left: 0;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n\n    &:before,\n    &:after {\n      content: "";\n      display: table;\n    }\n\n    &:after {\n      clear: both;\n    }\n\n    .slick-loading & {\n      visibility: hidden;\n    }\n  }\n  \n  .slick-slide {\n    float: left;\n    height: 100%;\n    min-height: 1px;\n    [dir="rtl"] & {\n      float: right;\n    }\n    \n    img {\n      display: block;\n    }\n    \n    &.slick-loading img {\n      display: none;\n    }\n\n    display: none;\n\n    &.dragging img {\n      pointer-events: none;\n    }\n\n    & {\n      display: block;\n    }\n\n    .slick-vertical & {\n      display: block;\n      height: auto;\n      border: 1px solid transparent;\n    }\n  }\n  \n  .slick-arrow {\n    &.slick-hidden {\n      display: none;\n    }\n    \n    &.slick-prev,\n    &.slick-next {\n    &:focus-visible {\n        outline: solid 2px #015ecc;\n        border-radius: 4px;\n      }\n    }\n  }\n';

;// CONCATENATED MODULE: ./segments/desktop/core-components/carousel/slick-theme.scss.js
var SLICK_OPACITY_ON_HOVER = 1;
var SLICK_OPACITY_NOT_ACTIVE = 0.25;
var SLICK_OPACITY_DEFAULT = 0.75;
var SLICK_DOT_SIZE = 0.338;
var SLICK_NEXT_CHARACTER = "→";
var SLICK_PREV_CHARACTER = "←";
var SLICK_DOT_CHARACTER = "•";
var slickThemeStyle = '\n  .slick-list {\n    .slick-loading & {\n      background: #fff url("./ajax-loader.gif") center center no-repeat;\n    }\n  }\n\n  .slick-prev,\n  .slick-next {\n    position: absolute;\n    display: block;\n    height: 20px;\n    width: 20px;\n    line-height: 0;\n    font-size: 0;\n    cursor: pointer;\n    background: transparent;\n    color: transparent;\n    top: 50%;\n    -webkit-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n    padding: 0;\n    border: none;\n    outline: none;\n\n    &:hover,\n    &:focus {\n      outline: none;\n      background: transparent;\n      color: transparent;\n\n      &:before {\n        opacity: '.concat(SLICK_OPACITY_ON_HOVER, ";\n      }\n    }\n\n    &.slick-disabled:before {\n      opacity: ").concat(SLICK_OPACITY_NOT_ACTIVE, ";\n    }\n\n    &:before {\n      font-size: 1.125rem;\n      line-height: 1;\n      color: white;\n      opacity: ").concat(SLICK_OPACITY_DEFAULT, ';\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n    }\n  }\n\n  .slick-prev {\n    left: -25px;\n\n    [dir="rtl"] & {\n      left: auto;\n      right: -25px;\n    }\n\n    &:before {\n      content: ').concat(SLICK_NEXT_CHARACTER, ';\n\n      [dir="rtl"] & {\n        content: ').concat(SLICK_PREV_CHARACTER, ';\n      }\n    }\n  }\n\n  .slick-next {\n    right: -25px;\n\n    [dir="rtl"] & {\n      left: -25px;\n      right: auto;\n    }\n\n    &:before {\n      content: ').concat(SLICK_PREV_CHARACTER, ';\n\n      [dir="rtl"] & {\n        content: ').concat(SLICK_NEXT_CHARACTER, ";\n      }\n    }\n  }\n\n  .slick-dotted.slick-slider {\n    margin-bottom: 30px;\n  }\n\n  .slick-dots {\n    position: absolute;\n    bottom: -25px;\n    list-style: none;\n    display: block;\n    text-align: center;\n    padding: 0;\n    margin: 0;\n    width: 100%;\n\n    li {\n      position: relative;\n      display: inline-block;\n      height: 20px;\n      width: 20px;\n      margin: 0 5px;\n      padding: 0;\n      cursor: pointer;\n\n      button {\n        border: 0;\n        background: transparent;\n        display: block;\n        height: 20px;\n        width: 20px;\n        outline: none;\n        line-height: 0;\n        font-size: 0;\n        color: transparent;\n        padding: 5px;\n        cursor: pointer;\n\n        &:hover,\n        &:focus {\n          outline: none;\n\n          &:before {\n            opacity: ").concat(SLICK_OPACITY_ON_HOVER, ";\n          }\n        }\n\n        &:before {\n          position: absolute;\n          top: 0;\n          left: 0;\n          content: ").concat(SLICK_DOT_CHARACTER, ";\n          width: 20px;\n          height: 20px;\n          font-size: ").concat(SLICK_DOT_SIZE, ";\n          line-height: 20px;\n          text-align: center;\n          color: black;\n          opacity: ").concat(SLICK_OPACITY_NOT_ACTIVE, ";\n          -webkit-font-smoothing: antialiased;\n          -moz-osx-font-smoothing: grayscale;\n        }\n      }\n\n      &.slick-active button:before {\n        color: black;\n        opacity: ").concat(SLICK_OPACITY_DEFAULT, ";\n      }\n    }\n  }\n");

;// CONCATENATED MODULE: ./segments/desktop/core-components/carousel/carousel.scss.js






var StyledCarousel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "en6i2u80"
})(slickStyle, " ", slickThemeStyle, "  \n  .slick-slider{.slick-dots{z-index:", z_index/* LAYER_ONE */.KW, ";li{margin:0 4px;button{display:inline-block;width:11px;height:11px;border-radius:50%;border:1px solid ", colors/* default.asphalt */.Z.asphalt, ";opacity:1;background-color:transparent;&::before{display:none;}}&.slick-active{button{background-color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";border-color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";}}&:not(.slick-active):hover{button{background-color:#c5c7d0;}}}}}.slick-slider.focus{.slick-list{.slick-track{padding:48px 0;.slick-slide{.carousel-item{outline:none;transition:opacity 0.5s ease,transform 0.5s ease;transform:scale(1);opacity:0.3;}&.slick-active{&.slick-center{.carousel-item{transform:scale(1.175);}}.carousel-item{opacity:1;}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/carousel/carousel.js


function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var GO_TO_SPEED_MILLISECONDS = 500;
var GO_TO_ANIMATION_THROTTLE_DELAY = 100;
var PAUSE_AFTER_SWIPE_DELAY = 5000;
var ConditionalWrapper = function(param) {
    var condition = param.condition, wrapper = param.wrapper, children = param.children;
    return condition ? wrapper(children) : children;
};
var Carousel = /*#__PURE__*/ (0,react.forwardRef)(function(props, externalRef) {
    var slider = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(externalRef, function() {
        return {
            scrollToSlide: function scrollToSlide(index) {
                slider === null || slider === void 0 ? void 0 : slider.current.slickGoTo(index);
            },
            pause: function pause() {
                slider === null || slider === void 0 ? void 0 : slider.current.slickPause();
            },
            play: function play() {
                slider === null || slider === void 0 ? void 0 : slider.current.slickPlay();
            },
            next: function next() {
                slider === null || slider === void 0 ? void 0 : slider.current.slickNext();
            },
            prev: function prev() {
                slider === null || slider === void 0 ? void 0 : slider.current.slickPrev();
            }
        };
    }, []);
    // Items props
    var items = props.items, selectedIndex = props.selectedIndex, itemRenderer = props.itemRenderer, onSwipe = props.onSwipe, onChange = props.onChange, itemScale = props.itemScale, lazyLoad = props.lazyLoad;
    // Carousel props
    var autoplay = props.autoplay, autoplaySpeed = props.autoplaySpeed, infinite = props.infinite, slidesToShow = props.slidesToShow, easing = props.easing, arrows = props.arrows, nextArrow = props.nextArrow, prevArrow = props.prevArrow, dots = props.dots, className = props.className, responsive = props.responsive;
    // Advanced carousel props
    var centerMode = props.centerMode, centerPadding = props.centerPadding, defaultIndex = props.defaultIndex, swipeToSlide = props.swipeToSlide, showFocusEffect = props.showFocusEffect, defaultImage = props.defaultImage, carouselClassName = props.carouselClassName, onRefSet = props.onRefSet, focusAfterSwipe = props.focusAfterSwipe, disableSlideOnStartClick = props.disableSlideOnStartClick, speed = props.speed, beforeChange = props.beforeChange, draggable = props.draggable, _slidesToScroll = props.slidesToScroll, slidesToScroll = _slidesToScroll === void 0 ? 1 : _slidesToScroll, _focusOnSelect = props.focusOnSelect, focusOnSelect = _focusOnSelect === void 0 ? true : _focusOnSelect;
    if (!items) return null;
    // Arrange items in right format and order
    var defaultIndexNumber = Math.min(parseInt(defaultIndex), items.length);
    var hasDefault = defaultImage && defaultImage.src;
    var slides = (0,_to_consumable_array/* default */.Z)(items);
    if (hasDefault) {
        slides = (0,_to_consumable_array/* default */.Z)(items.slice(0, defaultIndexNumber)).concat([
            defaultImage
        ], (0,_to_consumable_array/* default */.Z)(items.slice(defaultIndexNumber)));
    }
    var handleSwipe = function(direction) {
        slider.current.slickPause();
        if (autoplay) {
            setTimeout(function() {
                return slider.current.slickPlay();
            }, PAUSE_AFTER_SWIPE_DELAY);
        }
        if (onSwipe) {
            onSwipe(direction);
        }
    };
    var handleChange = function(current) {
        if (onChange) {
            onChange(current);
        }
        if (focusAfterSwipe) {
            var _slider_current_innerSlider_list, _slider_current_innerSlider, _slider_current;
            slider === null || slider === void 0 ? void 0 : (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : (_slider_current_innerSlider = _slider_current.innerSlider) === null || _slider_current_innerSlider === void 0 ? void 0 : (_slider_current_innerSlider_list = _slider_current_innerSlider.list) === null || _slider_current_innerSlider_list === void 0 ? void 0 : _slider_current_innerSlider_list.click();
        }
    };
    var focusSlider = function() {
        var _slider_current_innerSlider, _slider_current;
        if (slider === null || slider === void 0 ? void 0 : (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : (_slider_current_innerSlider = _slider_current.innerSlider) === null || _slider_current_innerSlider === void 0 ? void 0 : _slider_current_innerSlider.list) {
            slider.current.innerSlider.list.setAttribute("tabindex", 0);
            slider.current.innerSlider.list.focus();
        }
    };
    var settings = {
        // Default settings
        className: classnames_default()((0,_define_property/* default */.Z)({
            center: centerMode,
            focus: showFocusEffect
        }, className, className)),
        speed: speed || GO_TO_SPEED_MILLISECONDS,
        dots: dots,
        focusOnSelect: focusOnSelect,
        onSwipe: handleSwipe,
        afterChange: handleChange,
        beforeChange: beforeChange,
        // User props
        infinite: infinite,
        slidesToScroll: slidesToScroll,
        arrows: arrows,
        nextArrow: nextArrow,
        prevArrow: prevArrow,
        swipeToSlide: swipeToSlide,
        slidesToShow: Math.min(slidesToShow, slides.length),
        centerPadding: centerPadding,
        easing: easing,
        centerMode: centerMode,
        autoplay: autoplay,
        autoplaySpeed: parseInt(autoplaySpeed),
        lazyLoad: lazyLoad,
        draggable: draggable
    };
    var onIndexChanged = function(selectedIndex) {
        var newIndex;
        if (selectedIndex !== null && centerMode) {
            newIndex = selectedIndex >= defaultIndexNumber && hasDefault ? selectedIndex + 1 : selectedIndex;
        } else {
            newIndex = defaultIndexNumber;
        }
        slider.current.slickGoTo(newIndex);
    };
    // Throttle and give some delay (100ms) because when the index changes
    // `slickGoTo` does not work properly when changing fast
    var throttledOnIndexChanged = (0,react.useCallback)(lodash_throttle_default()(onIndexChanged, GO_TO_SPEED_MILLISECONDS + GO_TO_ANIMATION_THROTTLE_DELAY, {
        trailing: true
    }), []);
    (0,react.useEffect)(function() {
        throttledOnIndexChanged(selectedIndex);
    }, [
        selectedIndex
    ]);
    (0,react.useEffect)(function() {
        if (slider === null || slider === void 0 ? void 0 : slider.current) {
            if (onRefSet) {
                onRefSet(slider.current);
            }
        }
    }, [
        slider
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCarousel, {
        className: classnames_default()("carousel", carouselClassName),
        onTouchStart: disableSlideOnStartClick ? null : focusSlider,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, _object_spread_props(_object_spread({
            ref: slider
        }, settings), {
            initialSlide: defaultIndexNumber,
            responsive: responsive,
            children: slides.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "carousel-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper, {
                        condition: itemScale != 1,
                        wrapper: function(children) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    transform: "scale(".concat(itemScale, ")")
                                },
                                children: children
                            });
                        },
                        children: itemRenderer(item, index)
                    })
                }, "slide_".concat(index));
            })
        }))
    });
});
Carousel.defaultProps = default_props/* default */.Z;
/* harmony default export */ var carousel = (Carousel);


/***/ }),

/***/ 26687:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    infinite: true,
    arrows: false,
    autoplay: false,
    defaultIndex: 2,
    slidesToShow: 3,
    easing: "cubic",
    itemScale: 1,
    autoplaySpeed: 3000,
    centerMode: true,
    centerPadding: "10%",
    swipeToSlide: true,
    showFocusEffect: true,
    pauseOnFocus: true,
    lazyLoad: false,
    dots: false,
    reducedVerticalPadding: false // TODO: barben i don't know if the current 48px you added in the css is a must, but it's much more then i need
});


/***/ })

}]);